const TransEs = {
  navbar: {
    home: "Inicio",
    aboutus: "Sobre nosotros",
    product: "Productos",
    productSub: {
      universalLifeInsurance: "Seguro de Vida Universal",
      indexedUniversal: (
        <>
          Seguro de Vida
          <br /> Universal Indexado
        </>
      ),
      termLifeInsurance: (
        <>
          Seguro de Vida
          <br />a Término
        </>
      ),
      criticalIllnessInsurance: (
        <>
          Seguro de
          <br /> Enfermedades Críticas
        </>
      ),
      compareProduct: "Comparar productos",
      compareDesc:
        "Descubra las principales diferencias de nuestro portafolio de productos de vida.",
    },
    agents: "Agentes",
    contactUs: "Contáctenos",
    faqs: "Preguntas Frecuentes",
    compareProducts: "Comparar Productos",
    universalLife: "Seguro de Vida Universal",
    indexedUniversalLife: "Seguro de Vida Universal Indexado",
    termLife: "Seguro de Vida a Término",
    criticalIllness: "Seguro de Enfermedades Críticas",
  },
  footer: {
    address: (
      <>
        American Fidelity International Ltd. (AFIL)
        <br /> The Grove, 21 Pine Rd, Belleville <br />
        Saint Michael, BB11113, Barbados
      </>
    ),
    number: "Teléfono: 1 (246) 367-8874",
    email: "life-service@americanfidelity.com",
    fax: "Fax: (441) 292-0665",
    navLinks: {
      Home: "Inicio",
      About_Us: "Sobre nosotros",
      Products: "Productos",
      FAQs: "Preguntas Frecuentes ",
      American_Fidelity: "American Fidelity",
      Learn_More: "Conozca más",
      AFIBL: "AFIL",
      Superior_Plan: "Superior Plan",
      Universal_Life: "Vida Universal",
      Benefits: "Beneficios",
      How_It_Works: "Cómo funciona",
      Indexed_Universal_Life: "Vida Universal Indexada",
      Optima_Plan: "Optima Plan",
      Select_Term: "Select Term",
      Vital_Plan: "Vital Plan",
      Critical_Illness: "Enfermedades Críticas",
      ContactUs: "Contáctenos",
      AdditionalBenefits: "Beneficios Adicionales",
      CoverageType: "Tipos de Cobertura",
    },
  },
  // WhyChoose HealthInsuranceHero.js
  provenExperience: "Experiencia Comprobada",
  provenExperienceDescription:
    "Asegurando vidas en el mercado por más de 20 años⁸.",
  flexibleProducts: "Productos Flexibles",
  flexibleProductsDescription:
    "Seguro de vida adaptado a las necesidades cambiantes a lo largo de la vida.",
  lastingCommitment: "Compromiso Duradero",
  lastingCommitmentDescription:
    "Nos comprometemos a acompañarte en el tiempo, ofreciéndote revisiones periódicas de tu póliza.",
  prestige: "Prestigio",
  PrestigeDescription:
    "Estamos respaldados por una respetada reputación en el mercado internacional. Nos esforzamos por mantener los más altos estándares y ofrecer un servicio de primera clase a nuestros clientes.",
  WhyChooseHeading: "¿Por qué contratar un Seguro de Vida con nosotros?",
  WhyChooseDescription:
    "Cuando eliges tu seguro de vida con nosotros, puedes esperar estabilidad, adaptabilidad y compromiso a largo plazo.",

  // Faqs left content
  faqsLefttitle: "¿Preguntas? Respuestas",
  faqsLeftHeading: "Preguntas Frecuentes",
  faqsLeftDescription:
    "Respondemos las principales dudas que pueden surgir al adquirir un seguro de vida.",
  faqsLeftButton: "Contáctenos",

  // Our Credential content
  ourCredentialHeading: "Credenciales de American Fidelity Assurance Company",
  historyTab: "Historia",
  historyTitle: "Líder en la industria de seguros por más de 62 años.",
  historyDescription:
    "American Fidelity International Ltd. es miembro de la familia de empresas American Fidelity® junto con su filial American Fidelity Assurance Company, una organización líder en la industria de seguros por más de 62 años.",
  historyLearnMore: "Conozca más",
  cultureTab: "Cultura",
  cultureFeatureOne:
    "Certificado Mejores Empresas para Trabajar<sup>3</sup> (2024-2025)",
  cultureFeatureTwo:
    "Mejores Lugares de Trabajo para Millennials por la Revista Fortune 2024<sup>4</sup>",
  cultureFeatureThree:
    "Mejores Empresas para Trabajar en Servicios Financieros y Seguros por la Revista Fortune 2024<sup>5</sup>",
  cultureFeatureFour:
    "Mejores Lugares para Trabajar en TI por Computerworld 2024<sup>6</sup>",
  cultureFeatureFive:
    "Empresas que se Preocupan por la Revista PEOPLE 2021<sup>7</sup>",

  // Our Products Content
  ourProductHeading: "Nuestros productos",
  universalLifeTab: "Vida Universal",
  universalLifeHeading: "Protección financiera de por vida",
  universalLifeDescriptionBold: "Protección financiera de por vida.",
  universalLifeDescription:
    "Un seguro de vida universal combina dos elementos importantes: protección y ahorro.",
  termLifeTab: "Seguro de Vida a Término",
  termLifeHeading:
    "Un producto competitivo que puede ayudar a garantizar la protección de sus seres queridos.",
  termLifeDescriptionBold:
    "Un producto competitivo que puede ayudar a garantizar la protección de sus seres queridos.",
  termLifeDescription:
    "El seguro de vida temporal puede ayudarle a proteger financieramente a sus seres queridos en caso de su fallecimiento.",
  criticalIllnessTab: "Enfermedades Críticas",
  criticalIllnessHeading:
    "Protección para ayudar con los costos de Enfermedades Críticas",
  criticalIllnessDescription:
    "El seguro de Enfermedades Críticas puede ayudar a brindar protección financiera para cubrir los costos de enfermedades críticas.",
  productMoreButton: "Más",
  productCompareButton: "Comparar planes",

  // About Us Banner
  aboutUsBannerTitle: "Compromiso con la Excelencia y el Liderazgo",
  aboutUsBannerDescription:
    "American Fidelity International Ltd. amplía sus servicios de seguros de vida y salud para clientes internacionales, reforzando su visión de protección para clientes latinoamericanos.",
  aboutUsBannerButton: "Desplácese para obtener más información",

  americanfidelityTitle: "Familia de empresas American Fidelity",
  americanfidelityDescription:
    "Nuestros pilares fundamentales de integridad, dedicación y excelencia son la base de todo lo que hacemos.",
  americanfidelityDescription2:
    "La familia de empresas American Fidelity se compone de numerosas empresas, incluida American Fidelity Corporation (AFC). AFC, a través de sus filiales, ofrece servicios financieros, seguros y soporte de recursos humanos. American Fidelity Assurance Company (AFA) y American Fidelity International Ltd. son subsidiarias de AFC.",
  americanfidelityAmount: "*Montos en USD (Dólares).",

  afaConsolidatedTextOne: "AFA Liquidez consolidada en 2024 <sup>8</sup>",
  afaConsolidatedTextTwo:
    "Beneficios acumulados consolidados de AFC pagados a clientes en 2024 <sup>8</sup>",
  afaConsolidatedTextThree:
    "Ingresos netos consolidados de AFC en 2024 <sup>8</sup>",

  //Values ​​that guide content
  valuesHeading: "Valores que guían nuestro camino",
  valuesDescription:
    "Las creencias fundamentales de American Fidelity para nuestros clientes son ser siempre justos, financieramente seguros, flexibles, enfocados y orientados al futuro.",
  valuesAMBestTab: "AM Best",
  AmBestTitle: "Calificación de Solidez Financiera A+ (Superior)",
  AmBestDescription1: `Desde 1982, American Fidelity Assurance Company ha obtenido continuamente la calificación de "A+" (Superior) por AM Best<sup>1</sup>.`,
  AmBestDescription2:
    "La compañía AM. Best es considerada como líder nacional en servicios de evaluación de compañías de seguros. AM. Best basa sus calificaciones en el análisis de la condición financiera y el desempeño operativo de las compañías de seguros en áreas de vital importancia tales como: solidez del balance, desempeño operativo, perfil comercial y gestión de riesgos empresariales.",
  valuesWardsTab: "Ward's",
  valuesWardsTitle: "Premio Ward's 50® Compañías de Vida y Salud 2024",
  valuesWardsDescription1:
    "American Fidelity Assurance Company ha sido incluida en la lista de las 50® compañías de seguros de vida y salud con mejor desempeño de Ward's en 2024.",
  valuesWardsDescription2:
    "Este honor reconoce el desempeño financiero de 50 empresas. Cada empresa ha superado todos los controles de seguridad y consistencia y ha logrado un desempeño superior durante los cinco años analizados<sup>2</sup>.",

  valuesOtherRewardsTab: "Otros Reconocimientos",

  //International Clients content
  internationalHeading: "Clientes internacionales",
  internationalDescription:
    "Desde 2001, American Fidelity International Ltd. ha logrado un gran éxito al ayudar a brindar soluciones de seguridad financiera a clientes internacionales.",
  internationalPurposeTitle: "Objetivo",
  internationalPurposeDesc1:
    "Los objetivos de American Fidelity International Ltd. se basan en dos principios básicos:",
  internationalPurposeDesc2:
    "Ofrecer a nuestros clientes internacionales productos de calidad para ayudarles a satisfacer sus necesidades financieras.",
  internationalPurposeDesc3:
    "Ayudar a proporcionar a nuestros clientes internacionales soluciones de protección financiera.",

  // Product Compare Content
  productCompareHeading: "Comparación de Productos",
  productCompareDescription:
    "Descubra las principales diferencias de nuestro portafolio de productos de seguro de vida.",

  termProductTitle: "Seguro a Término",
  termProductDescription1:
    "Personas y familias que necesitan cobertura asequible por un período limitado.",
  termProductDescription2:
    "Garantiza el pago de un beneficio por fallecimiento preestablecido a los beneficiarios del asegurado si el asegurado fallece durante el plazo especificado.",

  universalProductTitle: "Universal (Prime + Ultra III)",
  universalProductDescription1:
    "Personas que buscan flexibilidad en sus seguros de vida.",
  universalProductDescription2:
    "Para aquellos que deseen ajustar las primas y los beneficios por fallecimiento.",
  universalProductDescription3:
    "Personas interesadas en acumular valor en efectivo.",

  indexaProProductTitle: "Indexa Pro IUL",
  indexaProProductDescription1:
    "Para aquellos que buscan un potencial de crecimiento del valor en efectivo basado en el S&P 500.",
  indexaProProductDescription2:
    "Para aquellos que quieren una combinación de rendimiento a largo plazo y seguro de vida.",
  indexaProProductDescription3:
    "Para aquellos que quieren una combinación de rendimiento a largo plazo y seguro de vida.",

  criticalProductTitle: "Enfermedades Críticas",
  criticalProductDescription1:
    "Un producto, diseñado con un monto de beneficio previamente estipulado.",
  criticalProductDescription2:
    "Se activa en el momento crítico del diagnóstico de una enfermedad grave (tal y como se describe en la póliza), proporcionando un apoyo financiero esencial.",

  guaranteedPremium: "Prima garantizada",
  cashValue: "Valor en efectivo utilizable",
  premiumFlexibility: "Flexibilidad en las primas y en la frecuencia",
  deathBenefit: "Ajuste en el monto del beneficio por fallecimiento",
  loanDuration:
    "Duración de 10, 15, 20, 30, hasta los 85 años y hasta los 100 años",
  permanentPolicy: "Oportunidad de convertir a una póliza permanente",
  interestCredit: "Acreditación de intereses basada en el S&P 500®",
  interestCreditDesc:
    "(que puede aumentar y disminuir debido a las fluctuaciones normales del mercado)",
  duringTerms: "(Durante el plazo)",

  // Critical Page content
  criticalIllnessHeading:
    "Protección para ayudar con los costos de Enfermedades Críticas",
  criticalIllnessDescription:
    "El beneficio de enfermedad crítica puede ayudar a proporcionar protección financiera al asegurado en caso de que sufra una enfermedad grave o crítica cubierta por la póliza.",
  criticalIllnessTabDescriptionBold:
    "Protección para ayudar con los costos de Enfermedades Críticas.",
  criticalIllnessTabDescription:
    "El beneficio de enfermedad crítica puede ayudar a proporcionar protección financiera al asegurado en caso de que sufra una enfermedad grave o crítica cubierta por la póliza.",

  whyChooseIllness: {
    titleBold: "¿Por qué debería considerar ",
    titleRegular: "una póliza de Enfermedades Críticas?",
    subtitle: "Enfermedades Críticas",
    description:
      "El beneficio se le pagará directamente a usted para que pueda usarlo para ayudar a cubrir gastos, tales como:",
    reasons: {
      medicalDebts:
        "Deudas médicas no cubiertas por el seguro de salud tradicional",
      lossOfIncome: "Pérdida de ingresos o deudas existentes",
      educationCosts:
        "Costos escolares o universitarios y costos de cuidados de los niños durante la recuperación",
      rehabilitation:
        "Rehabilitación, cuidado personal en el domicilio del asegurado o de una enfermera calificada.",
    },
  },

  productOverview: {
    sectionTitle: "Enfermedad Crítica",
    heading: "Resumen del producto",
    whyConsiderHeadingBold: "¿Por qué debería considerar ",
    whyConsiderHeadingRegular: "una póliza de Enfermedades Críticas?",

    features: {
      upto80: {
        title: "Cobertura hasta los 80 años",
        description: "Renovabilidad garantizada hasta los 80 años.",
      },
      activation90: {
        title: "Activación: 90 días",
        description:
          "Período de espera de 90 días después de la fecha de vigencia de cobertura",
      },
      flexibility: {
        title: "Flexibilidad de uso",
        description:
          "Pago único que se puede utilizar para cubrir cualquier necesidad.",
      },
      extensiveCoverage: {
        title: "Amplia cobertura",
        description: "De $100.000 a $500.000",
      },
    },
  },

  criticalIllnessTab1: {
    heading: "Enfermedades, Condiciones y Procedimientos Quirúrgicos cubiertos",
    coveredFull: "100% Cubierto",
    coveredHalf: "25% Cubierto o Solo Una Vez",
  },

  coveredFull: {
    description:
      "La póliza de Enfermedades Críticas de American Fidelity International Ltd. paga el 100% del monto máximo del beneficio para las siguientes enfermedades, condiciones y cirugías, según se definen en la póliza:",
    diseases: {
      alzheimers: "Alzheimer",
      aorticSurgery: "Cirugía Aórtica",
      blindness: "Ceguera",
      cancer: "Cáncer",
      heartAttack: "Ataque Cardíaco (infarto de miocardio)",
      multipleSclerosis: "Esclerosis Múltiple",
      paralysis: "Parálisis",
      renalFailure: "Insuficiencia Renal",
      severeBurns: "Quemaduras Graves",
      stroke: "Accidente Cerebrovascular (ACV)",
      deafness: "Sordera",
      organTransplant: "Trasplante de Órganos",
    },
  },

  coveredHalf: {
    description1:
      "La póliza de Enfermedades Críticas de American Fidelity International Ltd. paga el 25% del monto máximo del beneficio una sola vez para los siguientes procedimientos, según se define en la póliza:",
    procedures: {
      coronaryBypass: "Bypass de la Arteria Coronaria",
      heartValveSurgery: "Cirugía de Válvulas Cardíacas",
      coronaryAngioplasty: "Angioplastia Coronaria",
    },
    description2:
      "La póliza de Enfermedades Críticas de American Fidelity International Ltd. paga el 25% del monto máximo del beneficio hasta un máximo de $25,000 solo una vez por:",
  },

  // Terms Life Content
  termsBannerHeading:
    "Un producto competitivo que puede ayudar a garantizar la protección de sus seres queridos.",
  termsBannerDescription:
    "El seguro de vida temporal puede ayudarle a brindarle protección con un monto fijo de dinero pagadero a su beneficiario si fallece dentro del plazo de la póliza y mientras esta aún esté activa.",

  select_term: "Select Term",
  main_benefits: "Principales beneficios ",
  of_the_policy: "de la póliza",
  guaranteed_premiums_title: "Primas Garantizadas",
  guaranteed_premiums_desc:
    "Garantía de que las primas de la póliza no aumentarán durante el período del plazo.",
  conversion_option_title: "Opción de Conversión",
  conversion_option_desc:
    "La póliza de seguro a término se puede convertir en una póliza de seguro permanente.",

  acceleratedDeathBenefitTitle: "Beneficio por Muerte Acelerada",
  acceleratedDeathBenefitDesc:
    "Proporciona asistencia financiera en caso de que padezca una enfermedad terminal, según se define en la póliza.",
  automaticBenefitRiderTitle:
    "Cláusula de Incremento Automático del Beneficio (ABI)",
  automaticBenefitRiderDesc:
    "Esta cláusula adicional aumenta automáticamente el beneficio por muerte de la póliza en un 3% al final de cada año durante los primeros 5 años de la póliza. Una vez que se alcanza el aumento del 15% en el beneficio por fallecimiento original, el beneficio permanece nivelado mientras la póliza permanezca vigente.",

  improve_protection: "Mejore su protección",
  with_additional_benefits: "con Opciones de Beneficios Adicionales",

  waiver_premium_title: "Cláusula Adicional de Exoneración de Prima ",
  waiver_premium_desc:
    "Esta cláusula exonera a la prima en su totalidad si el asegurado principal queda totalmente incapacitado durante al menos 180 días, según se define en la cláusula adicional.",

  accidental_death_title:
    "Cláusula de Beneficio por Muerte Accidental y Desmembramiento",
  accidental_death_desc:
    "Esta cláusula adicional proporciona protección adicional si la muerte resulta de un accidente o proporciona beneficios adicionales en caso de pérdida de visión o pérdida de una extremidad, según se define en la cláusula.",

  return_premium_title: "Cláusula de Devolución de Prima",
  return_premium_desc:
    "Reembolsa toda las Primas Acumuladas pagadas menos cualquier beneficio pagado el último día del período de plazo, siempre que la póliza aún esté activa. Disponible con el Término de 30 años y el Término hasta los 85 años de edad.",

  additional_insured_title:
    "Cláusula de Seguro Adicional a Término para Asegurados Adicionales",
  additional_insured_desc:
    "Esta cláusula adicional proporciona cobertura temporal para su cónyuge, familiares y/o socios comerciales.",

  variousTypesheading: "Varios tipos de cobertura disponibles",
  termsTable: {
    termType: "Tipo de Término",
    issueAge: "Edad de Emisión",
    minimumCovered: "Monto Mínimo para cubrir a todos los asegurados",
    minimumAmount: "Monto Mínimo de Beneficio:",
    term10: "Término 10",
    term15: "Término 15",
    term20: "Término 20",
    term30: "Término 30",
    term85: "Término hasta los 85 años ",
    term100: "Término hasta los 100 años ",
    years18_75: "18 a 75 años",
    years18_70: "18 a 70 años",
    years18_49: "18 a 49 años",
    years50_65: "50 a 65 años",
    years50_55: "50 a 55 años",
    years50_80: "50 a 80 años",
    amount500: "$500.000",
    amount300: "$300.000",
    amount250: "$500.000",
  },

  // Indexa universal content
  indexaBannerSubtitle: "Indexa Pro IUL",
  indexaBannerHeading:
    "Acredita intereses basados en el rendimiento de un índice financiero independiente (S&P 500®)",
  indexaBannerDescription:
    "Seguro que, a diferencia de las pólizas de vida universal tradicionales, puede acreditar intereses y tiene el potencial de generar valores de cuenta en su póliza para necesidades futuras.",

  title_how_indexa_works: "¿Cómo funciona Indexa Pro IUL?",
  how_indexa_worksDesc1:
    "Cuando se realiza un pago de prima, se deduce el cargo por gastos de prima y la parte restante se acredita al valor de su cuenta.",
  how_indexa_worksDesc2: `<span class="md:font-semibold">
                      Al comienzo de cada mes,
                    </span>
                   el valor de la cuenta se reduce por las deducciones mensuales.
                    <span class="md:font-semibold">
                      Al final del mes,
                    </span>
                    el valor de la cuenta en la Cuenta Fija se acredita con intereses. La Cuenta Indexada se acredita con intereses en el Aniversario del Segmento.`,
  premiums_title: "Primas",
  premiums_info:
    "(Menos el cargo por gastos de prima como se muestra en el anexo de la póliza).",
  interest_title: "Interés",
  monthly_deductions_title: "Deducciones mensuales",
  monthly_deductions_info:
    "Puede incluir una tarifa administrativa, el costo del seguro de la póliza, la carga inicial, el cargo por $1.000 del monto especificado y los cargos adicionales.",
  other_deductions_title: "Otras deducciones",
  other_deductions_info:
    "(Incluidas los rescates parciales y las penalidades por rescates parciales).",
  account_value: "Valor de la cuenta",

  fixed_and_indexed_accounts: "Cuenta fija y cuenta indexada",
  fixed_account_title: "Cuenta Fija",
  fixed_account_description:
    "La Cuenta Fija ofrece un crecimiento positivo y constante gracias a su tasa de interés fija.",
  fixed_account_benefits: "Podría ser adecuado para usted si desea:",
  fixed_account_stable_interest: "Tipos de interés más estables",
  fixed_account_lower_risk: "Menor riesgo",

  indexed_account_title: "Cuenta Indexada",
  indexed_account_description:
    "La cuenta Indexada ofrece el potencial de un mayor crecimiento en el valor de la cuenta porque está vinculada al rendimiento del índice S&P 500®.",
  indexed_account_benefits: "Podría ser adecuado para usted si:",
  indexed_account_higher_growth:
    "Desea un mayor potencial de crecimiento del valor de la cuenta.",
  indexed_account_higher_risk: "Se siente cómodo con un riesgo más alto.",

  indexed_universal_product: "Producto Universal Indexado",
  indexed_account_title2: `La Cuenta Indexada <span class="font-semibold">tiene un Techo, una Tasa de Participación y un Piso.</span>`,

  indexed_account_description2: `<span class="font-bold">La Tasa Máxima</span> establece un límite en la tasa de interés que se puede acreditar. Por lo tanto, <span class="font-bold">ganarás intereses cuando el S&P 500® </span> tenga un rendimiento positivo,  
pero nunca ganarás más allá del límite establecido en las Cuentas Indexadas.`,

  participation_rate_description: `<span class="font-bold">La Tasa de Participación</span> 
                    dicta el monto del aumento en el índice utilizado para calcular la tasa de interés indexada.`,

  floor_description: `<span class="font-bold">El Piso</span> ayuda a protegerse de las caídas del mercado. La tasa acreditada nunca será negativa, incluso si el S&P 500® tiene un rendimiento negativo.`,

  indexaBenefits: {
    improve_protection: `<stong class="font-semibold">Mejore su protección </stong> con las Opciones de Beneficios Adicionales`,
    discover_more:
      "Descubre más información sobre el seguro de vida universal indexado.",
    watch_video: "Ver video",
    benefitsOptions: {
      options1_title: "Cláusula Adicional de Exoneración de Prima Especificada",
      options1_Desc: `Esta cláusula adicional proporciona una cantidad específica que se aplicará como prima al valor de su cuenta si queda totalmente incapacitado, según se define en la cláusula adicional. <br /> <span class="text-[#A8A9AC] ">(LR230B)</span>`,
      options2_title:
        "Cláusula Adicional de Muerte Accidental y Desmembramiento",
      options2_Desc: `Esta cláusula adicional proporciona protección adicional si la muerte es el resultado de un accidente o proporciona beneficios adicionales en caso de pérdida de la visión o pérdida de una extremidad, según se define en la cláusula adicional. <br /> <span class="text-[#A8A9AC]">(LR234B)</span>`,
      options3_title:
        "Cláusula Adicional de Seguro de Vida a Término para Hijos",
      options3_Desc: `Esta cláusula adicional ofrece cobertura temporal para cada hijo elegible, según se define en la cláusula. <br />  <span class="text-[#A8A9AC] ">(LR231B)</span>`,
      options4_title:
        "Cláusula adicional de ingreso mensual por discapacidad con beneficio de cuidado a largo plazo",
      options4_Desc: `Esta cláusula adicional proporciona un ingreso mensual si usted queda totalmente discapacitado, según se define en la cláusula adicional. Además, se pagará un beneficio de cuidados prolongados si tiene una enfermedad crónica, según se define en la cláusula adicional.<br /> <span class="text-[#A8A9AC]">(LR233B)</span>`,
      options5_title: "Cláusula adicional de seguro a término nivelado",
      options5_Desc: `Proporciona cobertura temporal para cónyuge, familiares y/o socios comerciales. <br />  <span class="text-[#A8A9AC] ">(LR232B)</span>`,
    },
  },

  // Universal Page content
  universalBannerHeading: "El seguro de vida permanente combina dos elementos:",
  universalBannerDesc: "Ahorro y protección",

  universalBenefits: {
    improve_protection: `<stong class="font-semibold">Mejore su protección </stong> con las Opciones de Beneficios Adicionales`,
    benefitsOptions: {
      options1_title: "Cláusula Adicional de Exoneración de Prima Especificada",
      options1_Desc: `Esta cláusula adicional proporciona una cantidad específica que se aplicará como prima al valor de su cuenta si queda totalmente incapacitado, según se define en la cláusula adicional. <br /> <span class="text-[#A8A9AC] ">(LR154B)</span>`,
      options2_title:
        "Cláusula Adicional de Muerte Accidental y Desmembramiento",
      options2_Desc: `Esta cláusula adicional proporciona protección adicional si la muerte es el resultado de un accidente o proporciona beneficios adicionales en caso de pérdida de la visión o pérdida de una extremidad, según se define en la cláusula adicional.<br /> <span class="text-[#A8A9AC]">(LR195B)</span>`,
      options3_title: "Cláusula adicional de seguro a término nivelado",
      options3_Desc: `Proporciona cobertura temporal para cónyuge, familiares y/o socios comerciales. <br />  <span class="text-[#A8A9AC] ">(LR232B)</span>`,
      options4_title:
        "Cláusula Adicional de Seguro de Vida a Término para Hijos",
      options4_Desc: `Este anexo proporciona cobertura temporal para cada hijo elegible, según lo definido en el anexo.<br /> <span class="text-[#A8A9AC]">(LR121B)</span>`,
      options5_title:
        "Cláusula Adicional de Ingreso Mensual por Incapacidad con Cuidados Prolongados",
      options5_Desc: `Esta cláusula proporciona un ingreso mensual si usted queda totalmente discapacitado, según se define en la cláusula. Además, se pagará un beneficio de cuidados prolongados si tiene una enfermedad crónica, según se define en la cláusula.<br /> <span class="text-[#A8A9AC]">(LR162B)</span>`,
    },
  },

  main_benefits_title: "Principales beneficios de nuestra póliza",
  adjustable_premiums: "Primas Ajustables",
  build_cash_value: "Acumulación de valor en efectivo",
  adjustable_death_benefit: "Beneficio por Fallecimiento Ajustable",

  universeProduct_subtitle: "Productos Universales",
  universeProduct_heading: `<span class="font-semibold">Protección</span> y ahorro dentro de la misma póliza`,
  universeProtection_tab: "Protección",
  universeProtection_title: "El seguro de vida puede ayudar con:",
  universeProtection_desc: `Sustitución de ingresos <br />
              Pagar hipotecas y otras deudas
              <br />
              Pagar los gastos finales
              <br />
              Financiar la educación universitaria de los niños
              <br />
              Pagar los impuestos sobre el patrimonio`,

  universeCashValue_tab: "Ahorro",
  universeCash_title:
    "La acumulación de valores en efectivo se puede utilizar para:",
  universeCash_desc: `Complemento de jubilación <br />
    Compras importantes (vivienda, negocio) <br />
    Necesidades de efectivo de emergencia`,

  universal_types_title: "Dos tipos de productos de Seguro de Vida Universal",
  indexed_universal_life: "Seguro de Vida Universal Indexado",
  indexed_universal_life_desc: `El seguro de vida universal indexado (IUL) es una póliza de seguro de vida permanente que ofrece un beneficio por fallecimiento y un componente de valor en efectivo. La cuenta de valor en efectivo puede generar intereses al seguir un índice del mercado de valores, como el índice
                      <span class="font-bold">
                        Standard & Poor's® S&P 500®
                      </span> que puede aumentar y disminuir debido a las fluctuaciones normales del valor de mercado.`,
  indexed_min_death_benefit:
    "Monto mínimo de beneficio por fallecimiento requerido $250.000",
  indexed_issue_ages: "Edades de emisión: 18-80 años",
  indexed_learn_more: "Más información sobre Indexa Pro",
  universal_life: "Seguro de Vida Universal",
  universal_life_desc:
    "Una póliza de seguro de vida permanente que proporciona el beneficio de la acumulación de valor en efectivo a tasas competitivas.",
  universal_min_death_benefit:
    "Monto mínimo de beneficio por fallecimiento requerido $100.000",
  universal_issue_ages: "Edades de emisión: 18-80 años",
  universal_available_products: "Dos productos disponibles:",
  universal_product_1: "Platinum Ultra III",
  universal_product_2: "Prime",

  // other pages title
  securePageTitle: "Prácticas de Navegación Segura",
  termsPageTitle: "Términos de Uso",
  footnotesPageTitle: "Notas de pie de página",
  privacyPageTitle: "Aviso de Privacidad Vigente en Enero de 2025",
};

export default TransEs;
